import { Loading } from "@/components/common/Loading";
import { AssistanceService } from "@/service/services/Assistance.service";
import { companiesService } from "@/service/services/Companies.service";
import { requestTypeService } from "@/service/services/RequestType.service";
import { Alert, Snackbar, Typography } from "@mui/material";
import { useState } from "react";
import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalFooter } from "../ModalFooter";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalGroupCompanyDelete.type";
import ___PHRASE from "@/service/translate/translateService";
import { apiResponseTranslate } from "@/toolbox/helpers/responseApi.helper";

export const ModalGroupCompanyDelete: React.FC<Props> = (props:any): JSX.Element => {
    const { open, closeModal, groupCompany, onList, clearState } = props;
    const [loading, setLoading] = useState<boolean>(false);

       const [snackBarConfig, setSnackBarConfig] = useState<any>({
        open: false,
        severity: 'error',
        message: 'Error',
        autoHideDuration: 3000,
    });

    const onDeleted= async()=>{
        setLoading(true);
      await companiesService.deleteGroupCompany(groupCompany.id).then((data) => {
        let apimessagge = apiResponseTranslate(data?.data?.message || '');
        if(data.data.status){
              setSnackBarConfig({...snackBarConfig, open:true, severity:'success', message: apimessagge})
        }
        setTimeout(() => {
          onList && onList();
          closeModal && closeModal();
          setLoading(false);

        }, 2000)

      })
    }
  
  return (
    <>
    {loading && <Loading/>}
    <Snackbar
            open={snackBarConfig.open} 
            autoHideDuration={snackBarConfig.autoHideDuration} 
            onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))}
            anchorOrigin={{ vertical: 'top', horizontal:'right' }} >
            <Alert onClose={() => setSnackBarConfig(prev => ({ ...prev, open: false }))} severity={snackBarConfig.severity}>
                {snackBarConfig.message || ""}
            </Alert>
        </Snackbar>

    <Modal
      open={open}
      handleClose={closeModal}
      disableEscapeKeyDown disableBackdropClick
      size="xs"
    >
      <ModalHeader
        text={___PHRASE("eliminarEmpresa")}
        className='positionElements'
        onCancel={closeModal}
        clearState={clearState}
      >
      </ModalHeader>

      <ModalBody>
        <Typography variant="subtitle1" className="textColor"> 
          {___PHRASE("estaSeguroDeEliminarEstaCompañia")}
        </Typography>
      </ModalBody>

      <ModalFooter 
        confirmText={___PHRASE("Eliminar")}
        cancelText={___PHRASE("cancelar")}
        onCancel={closeModal}
        className="footerRight"
        onConfirm={onDeleted}
        clearState={clearState}
      />
    </Modal>
    </>
  )
}